import * as React from 'react';
import { Section } from './section';
import { TextareaField } from './textarea-field';
import {
  CommonAction,
  CommonReducerState
} from '@/features/line-items/line-item-form/common/form-reducer';
import { Dispatch } from 'react';

type NotesSectionProps = {
  state: CommonReducerState;
  dispatch: Dispatch<CommonAction>;
  errorFor: (field: string) => string | undefined;
};

export function NotesSection({ state, dispatch, errorFor }: NotesSectionProps) {
  return (
    <Section heading="Notes">
      <TextareaField
        id="line-item-notes"
        label="Team Notes (Optional)"
        value={state.formData.notes}
        onChange={value => dispatch({ type: 'SET_NOTES', value })}
        onBlur={() => dispatch({ type: 'BLUR_FIELD', field: 'notes' })}
        error={errorFor('notes')}
        placeholder="Add Notes"
        description="Tip: Use Team Notes to communicate context or justify decisions made for this line item."
      />
    </Section>
  );
}
